import * as action from './actions';
import * as service from './services';

export const swcStore = {
  action,
  service,
};
